var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d00e0e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77",
    x: 0,
    y: 0,
    width: 192,
    height: 192,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hangUp",
    transform: "translate(-53 -79.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14051",
    "data-name": "Group 14051",
    transform: "translate(77 96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -24, -16.12)",
    filter: "url(#Ellipse_77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_77-2",
    "data-name": "Ellipse 77",
    transform: "translate(24 16)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 70,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    transform: "translate(24 24.882)",
    fill: "#fff",
    stroke: "#d5d5d5",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 47.5,
    rx: 48.5,
    ry: 47.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 47.5,
    rx: 46.75,
    ry: 45.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14171",
    "data-name": "Group 14171",
    transform: "translate(116.032 119.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14126",
    "data-name": "Group 14126",
    transform: "matrix(-0.719, 0.695, -0.695, -0.719, 66.322, 34.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M14.5,13.726l1.168-1.46a5.977,5.977,0,0,0,1.752-4.381A6.277,6.277,0,0,0,15.377,3.5L13.041,1.46A6.68,6.68,0,0,0,8.66,0,6.418,6.418,0,0,0,3.987,2.044L2.527,3.5c-.177.188-.131.361-.292.584H1.943C.637,5.163-.454,7.9.191,11.1,3.163,25.991,16.33,37.2,32.032,38.557a9.53,9.53,0,0,0,5.549-1.168,5.747,5.747,0,0,0,1.46-1.168l1.46-1.46a5.777,5.777,0,0,0-.584-8.471l-2.336-2.044A6.971,6.971,0,0,0,33.2,22.493a6.42,6.42,0,0,0-4.673,2.044L27.359,26a7.212,7.212,0,0,0-1.46,2.336v.292l-.584-.292A26.249,26.249,0,0,1,11.293,15.773L11,15.481h.584A6.508,6.508,0,0,0,14.5,13.726Z",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 1.347, 4.832)",
    fill: "#4d4e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M0,1.461a1.465,1.465,0,0,0,1.46,1.46c10.392,0,18.988,8.114,18.988,18.111a1.46,1.46,0,0,0,2.921,0C23.368,9.46,13.487,0,1.459,0A1.464,1.464,0,0,0,0,1.461Z",
    transform: "translate(22.757 0)",
    fill: "#4d4e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M0,1.461a1.465,1.465,0,0,0,1.46,1.46c6.525,0,11.977,5.116,11.977,11.392a1.46,1.46,0,0,0,2.921,0C16.358,6.465,9.619,0,1.459,0A1.466,1.466,0,0,0,0,1.461Z",
    transform: "translate(22.464 7.011)",
    fill: "#4d4e50"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Hang_up",
    "data-name": "Hang up",
    transform: "translate(33.968 74.365)",
    fill: "#424242",
    fontSize: 16,
    fontFamily: "Raleway-Bold, Raleway",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.408,
    y: 0
  }, "Hang up"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangUp);
export default __webpack_public_path__ + "static/media/hangUp.882cdb692ee61e13dd4444a6a77c9734.svg";
export { ForwardRef as ReactComponent };